import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught an error", error, info);
  }

  handleRefresh = () => {
    window.location.reload();
  };

  render() {
    console.log(this.state.hasError);

    if (this.state.hasError) {
      return (
        <div style={styles.container}>
          <h1 style={styles.title}>Oops! Something went wrong.</h1>
          <p style={styles.message}>We hit a snag, but we’re on it!</p>
          <button onClick={this.handleRefresh} style={styles.button}>
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

const styles = {
  container: {
    // backgroundColor: "#FFD85F",
    backgroundColor: "#c8cdf3",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#000",
    textAlign: "center",
  },
  title: {
    fontSize: "2.5rem",
    marginBottom: "1rem",
  },
  message: {
    fontSize: "1.2rem",
  },
  button: {
    marginTop: "1rem",
    padding: "0.75rem 1.5rem",
    fontSize: "1rem",
    backgroundColor: "#000",
    color: "#FFD85F",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
};

export default ErrorBoundary;
